import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DashboardLayout from "tools/LayoutContainers/DashboardLayout";
import DashboardNavbar from "tools/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const sections = [
  {
    title: "MWATBI - Midwest Allied Trades of the Baking Industry",
    rows: [
      {
        name: "James Boddicker",
        company: "Sosland Publishing",
        role: "President",
        email: "jboddicker@sosland.com",
        term: "2026",
        category: "Regional",
        address: "n/a",
      },
    ],
  },
  {
    title: "SWAT - Southwest Allied Trades of the Baking Industry",
    rows: [
      {
        name: "Adam Ungashick",
        company: "Lesaffre",
        role: "President",
        email: "A.ungashick@lesaffre.com",
        term: "2026",
        category: "Regional",
        address: "n/a",
      },
    ],
  },
  {
    title: "NJ#9 - New Jersey Allied Trades of the Baking Industry",
    rows: [
      {
        name: "John Johansen",
        company: "Malt Products",
        role: "Past President",
        email: "john@maltproducts.com",
        term: "2026",
        category: "Regional",
        address: "n/a",
      },
    ],
  },
];

function SectionGrid({ title, rows, onSelect }) {
  return (
    <MDBox p={3}>
      <MDBox mb={3} p={2}>
        <MDTypography variant="h5" fontWeight="medium" pb={2}>
          {title}
        </MDTypography>

        <Grid container spacing={2}>
          {rows.map((member) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={`${title}-${member.name}-${member.company}`}>
              <Card
                onClick={() => onSelect({ ...member, section: title })}
                sx={{
                  p: 2,
                  height: "100%",
                  cursor: "pointer",
                  border: "1px solid",
                  borderColor: "grey.300",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: 4,
                    borderColor: "primary.main",
                  },
                }}
              >
                <MDTypography variant="h6" fontWeight="bold" mb={1}>
                  {member.name}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.role}
                </MDTypography>
                <MDTypography variant="button" color="text" display="block">
                  {member.company}
                </MDTypography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default function Regional() {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <DashboardLayout>
      <DashboardNavbar onSsearch={false} />
      <MDTypography variant="h5" fontWeight="medium" pb={3}>
        ATBI Regional Divisions
      </MDTypography>
      <MDBox display="flex" alignItems="center">
        <Card sx={{ overflow: "visible", width: "100%" }}>
          {sections.map((section) => (
            <SectionGrid key={section.title} title={section.title} rows={section.rows} onSelect={setSelectedMember} />
          ))}
        </Card>
      </MDBox>

      <Dialog open={Boolean(selectedMember)} onClose={() => setSelectedMember(null)} fullWidth maxWidth="sm">
        <DialogTitle>{selectedMember?.name}</DialogTitle>
        <DialogContent>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Section:</strong> {selectedMember?.section || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Role:</strong> {selectedMember?.role || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Term:</strong> {selectedMember?.term || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Company:</strong> {selectedMember?.company || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Category:</strong> {selectedMember?.category || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block" mb={1}>
            <strong>Email:</strong> {selectedMember?.email || "N/A"}
          </MDTypography>
          <MDTypography variant="button" color="text" display="block">
            <strong>Address:</strong> {selectedMember?.address || "N/A"}
          </MDTypography>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}
